<template>
    <carousel :perPage="1" :autoplay="false" :autoplayTimeout="5000" :paginationEnabled="false" easing="ease">
        <slide>
            <img src="../assets/slider/1.jpg" alt="Sprintcars" class="img-fluid">
            <div class="col-sm-4 offset-sm-4 my-auto"></div>
        </slide>
        <slide>
            <img src="../assets/slider/2.jpg" alt="Sprintcars" class="img-fluid">
            <div class="col-sm-4 offset-sm-4 my-auto"></div>
        </slide>
        <slide>
            <img src="../assets/slider/3.jpg" alt="Sprintcars" class="img-fluid">
            <div class="col-sm-4 offset-sm-4 my-auto"></div>
        </slide>
    </carousel>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        name: "HeaderCarousel",
        components: {
            Carousel,
            Slide,
        }
    }
</script>

<style scoped>

</style>
